module.exports = __webpack_public_path__ + "img/map.0e91f9b9.png";